import { render, staticRenderFns } from "./Home6.vue?vue&type=template&id=1286269d&"
import script from "./Home6.vue?vue&type=script&lang=js&"
export * from "./Home6.vue?vue&type=script&lang=js&"
import style0 from "./Home6.vue?vue&type=style&index=0&id=1286269d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports